module.exports = __webpack_public_path__ + "img/login4.7cf802a1.png";